import logo from "./logo.svg";
import "./App.css";
import AppointmentForm from "./Components/AllComponents/Apoinment";
import Sidebar from "./Components/AllComponents/Sidebar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Components/Pages/Home";
function App() {
  
    return (
      // <BrowserRouter>
      //   <Sidebar>
      //     <Routes>
      //       <Route path="/" element={<Home/>} />
      //       <Route path="/dashboard" element={<AppointmentForm />} />
      //       <Route path="/about" element={<AppointmentForm />} />
      //       <Route path="/comment" element={<AppointmentForm />} />
      //       <Route path="/analytics" element={<AppointmentForm />} />
      //       <Route path="/product" element={<AppointmentForm />} />
      //       <Route path="/productList" element={<AppointmentForm />} />
      //     </Routes>
      //   </Sidebar>
      // </BrowserRouter>
      <><h1>Hiiiii</h1></>
    );
};
  

export default App;
